export function inject_style(text) {
  if (typeof document !== 'undefined') {
    var style = document.createElement('style')
    style.dataset.baseUi = "true"
    var node = document.createTextNode(text)
    style.appendChild(node)
    document.head.appendChild(style)
  }
}